import { useMutation, useQueryClient } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const removeReaction = async (postId: string) => {
	const response = await cmsClient.delete(
		`/social-posts/${postId}/delete-user-reaction/`
	);
	return response.data;
};

const useRemoveReaction = () => {
	const queryClient = useQueryClient();

	return useMutation(removeReaction, {
		onSettled: () => {
			queryClient.invalidateQueries(["social-posts"]);
		}
	});
};

export default useRemoveReaction;
